module.exports = __webpack_public_path__ + "static/media/10FootballRedAQ5699.72e212d6.PNG";